import styled from "styled-components";

export const Main = styled.main`
  display: flex;
  justify-content: flex-end;

  #projects h1 {
    margin-bottom: 20px;
  }

  .colored-box {
    width: 87%;
    background-color: rgba(100, 100, 200, 0.5);
    padding-bottom: 50px;
    scroll-behavior: smooth;

    #projects, #aboutme {
      margin-top: 200px;
      margin-bottom: 100px;
    }

    .first-section {
      min-height: calc(90vh - 100px);
    }

    .title-container {
      margin-left: -45px;
      @media screen and (max-width: 370px) {
        margin-left: -30px;
      }
      h1 {
        margin-top: 10vh;
        color: #333;
        font-size: 32px;
        font-weight: 400;
        position: relative;
        opacity: 1;
      }

      h6 {
        max-width: 300px;
        font-size: 20px;
        font-weight: 500;
        color: #666;
        position: relative;
        opacity: 1;
        margin-left: 60px;
      }
    }

  }
`;

export const TitleImage = styled.div`
  margin-top: 60px;
  display: flex;
  justify-content: center;

  .title-img {
    width: 65%;
  }

  .tran {
    filter: blur(4px);
    -webkit-filter: blur(4px);
  }
`;

export const ContactTitle = styled.div`
  margin-top: 20px;
  h1 {
    color: #333;
    font-weight: 400;
    margin-left: calc(13vw - 45px);

    @media screen and (max-width: 370px) {
      margin-left: calc(13vw - 30px);
    }
  }
  
`;

